import { Label } from "flowbite-react";
export default Label;
